import ShareToStory from "src/shared/components/ShareToStory";
import FullScreenCardPage from "./FullScreenCardPage";
import type { RemoteSlideProps, Slide } from "./types";
import { resolveText, type SlideText } from "./text";
import styles from "./ShareToStorySlide.module.css";

export const ShareToStorySlide = (
  defaultCopy: SlideText,
  displayCopy: SlideText,
  imageUrl: string,
  displaySubCopy?: SlideText,
): Slide => {
  return {
    remote: (props: RemoteSlideProps) => (
      <ShareToStory imageUrl={imageUrl} defaultCopy={resolveText(defaultCopy)} {...props} />
    ),
    display: () => (
      <FullScreenCardPage>
        <div className={styles.displayHeadline}>
          {resolveText(displayCopy)}
          {displaySubCopy && <p>{resolveText(displaySubCopy)}</p>}
        </div>
      </FullScreenCardPage>
    ),
  };
};
